export default __webpack_public_path__ + "static/media/icon-pengaturan-ac.c8f28902.png";